import { render, staticRenderFns } from "./KioskTablesPreset.vue?vue&type=template&id=079115e2&"
import script from "./KioskTablesPreset.vue?vue&type=script&lang=js&"
export * from "./KioskTablesPreset.vue?vue&type=script&lang=js&"
import style0 from "./KioskTablesPreset.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "KioskTablesPreset.vue"
export default component.exports